import { render, staticRenderFns } from "./InternetAndMobileAdvantages.vue?vue&type=template&id=7767e8d6&scoped=true&"
import script from "./InternetAndMobileAdvantages.vue?vue&type=script&lang=js&"
export * from "./InternetAndMobileAdvantages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7767e8d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7767e8d6')) {
      api.createRecord('7767e8d6', component.options)
    } else {
      api.reload('7767e8d6', component.options)
    }
    module.hot.accept("./InternetAndMobileAdvantages.vue?vue&type=template&id=7767e8d6&scoped=true&", function () {
      api.rerender('7767e8d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/demands/showcase/internetandmobileoffers/components/InternetAndMobileAdvantages.vue"
export default component.exports